import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';
import { ScheduleTime } from 'src/app/shared/models/schedule-time.model';
import { Schedule } from 'src/app/shared/models/schedule.model';
import moment from 'moment';


export const checkLunchTimeStartValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const openingHour: { hour: number, minute: number } = control.get('openingHour').value;
    const closingHour: { hour: number, minute: number } = control.get('closingHour').value;
    const lunchStartHour: { hour: number, minute: number } = control.get('lunchStartHour').value;
    if (lunchStartHour.hour > 0 || lunchStartHour.minute > 0) {
        if (!(ScheduleTime.returnSumOfTime(lunchStartHour) > ScheduleTime.returnSumOfTime(openingHour) &&
            ScheduleTime.returnSumOfTime(lunchStartHour) < ScheduleTime.returnSumOfTime(closingHour))) {
            return { 'lunchTimeStartError': true };
        }
    }
    return null;
};

export const checkLunchTimeEndValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const closingHour: { hour: number, minute: number } = control.get('closingHour').value;
    const lunchStartHour: { hour: number, minute: number } = control.get('lunchStartHour').value;
    const lunchEndHour: { hour: number, minute: number } = control.get('lunchEndHour').value;
    if (lunchEndHour.hour > 0 || lunchEndHour.minute > 0) {
        if (!(ScheduleTime.returnSumOfTime(lunchEndHour) > ScheduleTime.returnSumOfTime(lunchStartHour) &&
            ScheduleTime.returnSumOfTime(lunchEndHour) < ScheduleTime.returnSumOfTime(closingHour))) {
            return { 'lunchTimeEndError': true };
        }
    }
    return null;
};

export const chekClosingHourValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const openingHour: { hour: number, minute: number } = control.get('openingHour').value;
    const closingHour: { hour: number, minute: number } = control.get('closingHour').value;
    if (!(ScheduleTime.returnSumOfTime(closingHour) > ScheduleTime.returnSumOfTime(openingHour))) {
        return { 'closingHourError': true };
    }
    return null;
};

export const checkStartEndScheduleDate: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const fullYear = control.get('fullYear').value;
    if (!fullYear) {
        if (!control.get('startDate').value) {
            return { 'startDateRequired': true };
        }
        if (!control.get('endDate').value) {
            return { 'endDateRequired': true };
        }
        const startDate = Schedule.convertNgbDataStructureToDateString(control.get('startDate').value);
        const endDate = Schedule.convertNgbDataStructureToDateString(control.get('endDate').value);
        if (startDate && endDate) {
            if (moment(endDate, 'YYYY-MM-DD').isBefore(moment(startDate, 'YYYY-MM-DD'))) {
                return { 'endBeforeStart': true };
            }
        }
    }
    return null;
};
